import React from "react"
import PropTypes from "prop-types"

import { ResponsiveDialog, ConfirmationDialog } from "ui-Dialog"
import DialogFormFrame from "./DialogFormFrame"

export default class FormDialog extends React.Component {
  static propTypes = {
    ...DialogFormFrame.propTypes,
    confirmDirty: PropTypes.bool,

    onClose: PropTypes.func,
    onRunMutation: PropTypes.func,
    onSubmit: PropTypes.func,
  }

  static defaultProps = {
    confirmDirty: true,
  }

  state = { confirmCancel: false }

  _handleSubmitted = ({ result }) => {
    const { onClose } = this.props

    if (result && onClose) {
      onClose()
    }
  }

  _handleCancel = () => {
    const { confirmDirty } = this.props

    if (this._mutation.isDirty() && confirmDirty) {
      this.setState({ confirmCancel: true })
    } else {
      this._cancel()
    }
  }

  _captureMutation = m => (this._mutation = m)
  _handleConfirmCancel = () => this.setState({ confirmCancel: false }, () => this._cancel())
  _handleDontCancel = () => this.setState({ confirmCancel: false })

  _cancel() {
    const { onClose } = this.props
    this._mutation.reset()

    if (onClose) {
      onClose()
    }
  }

  render() {
    const {
      confirmDirty,
      open,

      onClose,
      onRunMutation,
      onSubmit,

      ...otherProps
    } = this.props

    return (
      <ResponsiveDialog open={open} onClose={this._handleCancel} disableBackdropClick>
        <DialogFormFrame
          onSubmitted={this._handleSubmitted}
          onCancel={this._handleCancel}
          mutationRef={this._captureMutation}
          {...otherProps}
        />
        <ConfirmationDialog
          title="Discard?"
          open={this.state.confirmCancel}
          onOk={this._handleConfirmCancel}
          onCancel={this._handleDontCancel}
          okLabel="Discard"
        >
          Any changes will be lost.
        </ConfirmationDialog>
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/FormDialog.js